import { render, staticRenderFns } from "./InitialView.vue?vue&type=template&id=0c55dfd5&scoped=true&"
import script from "./InitialView.vue?vue&type=script&lang=js&"
export * from "./InitialView.vue?vue&type=script&lang=js&"
import style0 from "./InitialView.vue?vue&type=style&index=0&id=0c55dfd5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c55dfd5",
  null
  
)

/* custom blocks */
import block0 from "./InitialView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports